export class TemplateModel {
  public templateHashID: string;
  public templateName: string;
  public templateType: string;
  public subjectHTml: string;
  public bodyHTml: string;
  public description: string;
  public editorType: string;
  public emailTemplatePlaceHolder: EmailTemplatePlaceHolderModel[];
  public emailTemplateNameHashId: string = '';

  public customerHashId: string = '';
  public instanceHashId: string = '';
  public companyHashId: string = '';
  public organizationHashId: string = '';
  public svgHashId: string = '';
  public emailAddresses: string;
  public isEmailTemplate: boolean;
  public isWebTemplate: boolean;
  public emailRecipients: EmailRecipientsModel;

  public instanceName: string;
  public customerName: string;
  public companyName: string;
  public sharedVehicleGroupName: string;
  public organizationName: string;

  public isChecked: boolean;
  public isEditable: boolean;
  public isDeletable: boolean;
  public isActive: boolean = true;
}

export class EmailTemplatePlaceHolderModel {
  public placeHolder: string;
  public placeHolderValue?: any;
}

export class EmailRecipientsModel {
  public isWegoAdmin: boolean;
  public isWegoAdminTicked: boolean;
  public isDriver: boolean;
  public isDriverTicked: boolean;
  public isNextDriver: boolean;
  public isNextDriverTicked: boolean;
  public isRecipientsEnable: boolean;

  public customRecipientsModel: EmailCustomRecipientsModel[];
}

export class EmailCustomRecipientsModel {
  public roleHashId: string;
  public presentationName: string;
  public isTicked: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/template/models/template.model.ts